/*global Liferay */
import React, { useState } from 'react';
import Frame from 'react-frame-component';
import HappinessMeterForm from "./HappinessMeterForm";

import "./happiness-meter.css";
import { config } from '../../utils/constants';
import axios from "axios";

const HappinessMeter = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [result, setResult] = useState(null);
  const closePopUp = () => {
    setShowPopup(false);
  };

  const handleHappinessMeter = async () => {
    setShowPopup(true);
    const requestBody = {
      "languageId": Liferay.ThemeDisplay.getLanguageId().split("_")[0] || "en",
      "baseURL": Liferay.ThemeDisplay.getCDNBaseURL(),
      "userName": Liferay.ThemeDisplay.isSignedIn() ? Liferay.ThemeDisplay.getUserName() : null,
      "userEmail": Liferay.ThemeDisplay.isSignedIn() ? Liferay.ThemeDisplay.getUserEmailAddress() ? Liferay.ThemeDisplay.getUserEmailAddress() : null : null
    };
    const requestConfig = {
      url: `${config.backendBaseAddress}${config.happinessMeter}`,
      method: 'POST',
      data: requestBody
    };
    setResult(await axios.request(requestConfig));
  };
  return (
    <>
         <div className="happiness-meter-container">
            <div onClick={handleHappinessMeter}>
               <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.4327 22.8162C12.1667 22.8162 9.0942 18.8521 8.96551 18.6834L10.8532 17.2434L9.90936 17.9635L10.8516 17.2414C10.8763 17.2733 13.352 20.4419 16.4327 20.4419H16.4432C18.2137 20.4378 19.9306 19.3617 21.5461 17.2434L23.4338 18.6834C21.3424 21.4258 18.987 22.8162 16.4327 22.8162ZM16 6.37437C10.6924 6.37437 6.37426 10.6926 6.37426 16.0004C6.37426 21.3078 10.6924 25.6256 16 25.6256C21.3077 25.6256 25.6259 21.3078 25.6259 16.0004C25.6259 10.6926 21.3077 6.37437 16 6.37437ZM16 28C9.38324 28 4 22.617 4 16.0004C4 9.38334 9.38324 4 16 4C22.6169 4 28.0001 9.38334 28.0001 16.0004C28.0001 22.617 22.6169 28 16 28Z" fill="#002F70"></path></svg>
            </div>
         </div>
         {showPopup &&
      <div className='hm-modal-overlay'>
               <div className='hm-modal'>
                  <div className="hm-container">
                     <div className="otp-model-header d-none">
                        {Liferay.get("happy-meter-feedback")}
                     </div>
                     <div className="otp-model-body">
                        <Frame className="hm-iFrame">
                       {result && <HappinessMeterForm userData={result} />}
                        </Frame>
                     </div>
                  </div>
                  <button type="button" className="hm-modal-closeButton close"
          data-dismiss="modal" aria-label="Close" onClick={closePopUp}>
                     <span aria-hidden="true">
                        X
                     </span>
                  </button>
               </div>
            </div>
      }
      </>);

};

export default HappinessMeter;